export default __webpack_public_path__ + "images/39d1c0b681b177c382c81d71dacbc821.svg";